import { AsyncStateStatus } from '../root.types'

/**
 * Redux Actions Company
 * @typedef ContactsTypes
 * @namespace ContactsTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 * <ul>
 *   <li>@contacts/contactsPersonRequest</li>
 *   <li>@contacts/contactsCompanyRequest</li>
 * </ul>
 * @memberof ContactsTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum ContactsTypes {
    CONTACTS_REQUEST = '@contacts/contactsRequest',
}

export interface IActionContacts {
    readonly filters: IFiltersContacts
}

export interface IFiltersContacts {
    readonly phone?: string
    readonly email?: string
}

export interface IContactsState {
    readonly status: AsyncStateStatus
    readonly data: Array<any>
}

export interface ContactsState {
    request: IContactsState
}
